﻿import { loadScriptOnce } from "@js/core/loaders/script-loader";
import { loadStyleOnce } from "@js/core/loaders/style-loader";

export async function ensureJQuery() {
    if (window.jQuery) return window.jQuery;
    await loadScriptOnce("/lib/jquery/dist/jquery.min.js");
    return window.jQuery;
}

export async function ensureBootstrap() {
    if (window.bootstrap) return window.bootstrap;
    await loadScriptOnce("/lib/bootstrap/dist/js/bootstrap.bundle.min.js");
    return window.bootstrap;
}

export async function ensureLazySizes() {
    if (window.lazySizes) return window.lazySizes;
    await loadScriptOnce("https://cdn.multifonks.com/Library/Lazysizes/lazysizes.min.js");
    return window.lazySizes;
}

export async function ensureWOW() {
    if (window.WOW) return window.WOW;
    await loadStyleOnce("/css/animate.css");
    await loadScriptOnce("//cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js");
    return window.WOW;
}

export async function ensureSelect2() {
    await ensureJQuery();

    await loadStyleOnce("https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css");

    if (window.jQuery?.fn?.select2) {
        return window.jQuery.fn.select2;
    }

    await loadScriptOnce("https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js");
    return window.jQuery?.fn?.select2;
}

export async function ensureSwiper() {
    if (window.Swiper) return window.Swiper;
    await loadStyleOnce("//cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css");
    await loadScriptOnce("//cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js");
    return window.Swiper;
}

export async function ensureWaypoints() {
    await ensureJQuery();

    if (window.jQuery?.fn?.waypoint) return window.jQuery.fn.waypoint;
    await loadScriptOnce("//cdnjs.cloudflare.com/ajax/libs/waypoints/4.0.0/jquery.waypoints.min.js");
    return window.jQuery?.fn?.waypoint;
}

export async function ensureFancybox() {
    if (window.Fancybox) return window.Fancybox;
    await loadStyleOnce("//cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css");
    await loadScriptOnce("//cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js");
    return window.Fancybox;
}

export async function ensureCountUp() {
    if (window.countUp?.CountUp) return window.countUp;
    await loadScriptOnce("/lib/count-up/countUp.umd.js");
    return window.countUp;
}

export async function ensureParsley(locale = "tr") {
    // English messages are built into parsley.min.js; other languages need their i18n file.
    await ensureJQuery();

    if (!window.Parsley) {
        await loadScriptOnce("/lib/parsley.js/parsley.min.js");
    }

    if (locale && locale !== "en") {
        await loadScriptOnce(`/lib/parsley.js/i18n/${locale}.js`);
    }

    if (window.Parsley && locale) {
        try {
            window.Parsley.setLocale(locale);
        } catch (_) {
            // ignore
        }
    }

    return window.Parsley;
}

export async function ensureInputmask() {
    await ensureJQuery();

    if (window.jQuery?.fn?.inputmask) {
        return window.jQuery.fn.inputmask;
    }

    await loadScriptOnce("/lib/jquery.inputmask/jquery.inputmask.min.js");
    return window.jQuery?.fn?.inputmask;
}
